import BaseModel from '@/models/BaseModel'
import { required } from 'vue-mc/validation'

export default class Balance extends BaseModel {
  default () {
    return {
      restaurant: null
    }
  }

  options () {
    return {
      identifier: 'uuid',
      methods: {
        list: 'GET',
        add: 'POST',
        detail: 'GET'
      }
    }
  }

  getDefaultMethods () {
    return {
      fetch: 'GET',
      save: 'POST',
      update: 'PUT',
      create: 'POST',
      patch: 'PUT',
      delete: 'POST'
    }
  }

  validation () {
    return {
      restaurant: [ required ]
    }
  }

  shouldPatch () {
    return true
  }

  add (amount) {
    let method = this.getOption('methods.add')
    let route = this.getRoute('add')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)
    let data = amount

    return this.createRequest({ method, url, headers, data }).send()
  }

  detail () {
    let method = this.getOption('methods.detail')
    let route = this.getRoute('detail')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers }).send()
  }

  list (data = {}) {
    let method = this.getOption('methods.list')
    let route = this.getRoute('list')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    const query = Object.entries(data).reduce((acc, num, index) => {
      acc += index > 0 ? '&' : ''
      acc += `${num[0]}=${num[1]}`
      return acc
    }, '')

    url = query ? `${url}?${query}` : url
    return this.createRequest({ method, url, headers }).send()
  }

  routes () {
    return {
      list: `${this.API_BASE}/v1/balances`,
      add: `${this.API_BASE}/v1/restaurants/${this.restaurant._id}/balance`,
      detail: `${this.API_BASE}/v1/restaurants/${this.restaurant._id}/balance`,
      fetch: `${this.API_BASE}/v1/balances`
      // save: `${this.API_BASE}/v1/balance`,
    }
  }
}
